import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Element } from '../models/element.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ElementService {
  private apiUrl = environment.apiUrl + environment.elementPath;

  constructor(private http: HttpClient) {}

  getElements(): Observable<Element[]> {
    return this.http.get<Element[]>(`${this.apiUrl}`);
  }
}
